import React from 'react';
import { InjectedBreakpointsProps, withBreakpoints } from 'react-match-breakpoints';

import { Line } from 'app/page/orders/model/products-summary';
import { Typography } from 'app/components/domain/typography';
import { I18nUtils } from 'app/utils/i18n-utils';
import { i18n } from 'app/i18n';
import { CurrencyUtils } from 'app/utils/currency-utils';
import { EquipmentLineBase } from 'app/components/domain/summary-group/equipment/line/equipment-line-base';
import { BreakpointsUtils } from 'app/utils/breakpoints-utils';

import styles from './equipment-line.module.scss';

interface OwnProps {
    line: Line;
}

type Props = OwnProps & InjectedBreakpointsProps;

const EquipmentLineComponent: React.FC<Props> = (props) => {
    const { line, breakpoints } = props;

    const isOnDesktop: boolean = !BreakpointsUtils.isOnMobile(breakpoints);

    return (
        <EquipmentLineBase
            title={
                <Typography component="span" variant="body1">
                    {line.title}
                </Typography>
            }
            quantity={
                <Typography variant="body1" component="span" className={styles.quantityColumn}>
                    {isOnDesktop
                        ? line.quantity
                        : I18nUtils.richMessage(i18n.summary.productDetails.group.equipment.quantityMobile, {
                              quantity: line.quantity,
                          })}
                </Typography>
            }
            prices={
                <>
                    {!isOnDesktop && (
                        <Typography variant="body1" component="span" className={styles.totalPrice}>
                            {i18n.summary.productDetails.group.equipment.totalPriceMobile}
                        </Typography>
                    )}
                    <div className={styles.prices}>
                        <Typography variant="body1" component="span">
                            {line.priceText}
                        </Typography>
                        <Typography variant="body1" component="span">
                            {CurrencyUtils.formatCurrencyValue(line.totalPrice)}
                        </Typography>
                    </div>
                </>
            }
        />
    );
};

export const EquipmentLine = withBreakpoints(EquipmentLineComponent);
